import { useContext } from "react";
import { useScopeBar } from "common-client/utils/search";
import { spacing } from "../../stitches.config";
import { AuthContext } from "../Authorization/AuthContext";
import { HorizontalScrollBar } from "../Common/HorizontalScrollBar/HorizontalScrollBar";
import { Icon } from "../Common/Icons/LucideIcons";
import { Body } from "../Common/Typography";
import {
  CancelButton,
  ScopeBarContainer,
  ScopeChip,
} from "./__styles__/SearchScopeBar";
import { SearchContext } from "./SearchContext";

export const SearchScopeBar = () => {
  const { setManualScopes } = useContext(SearchContext);
  const { account } = useContext(AuthContext);

  const {
    selectedItems,
    unselectedChildren,
    hasSingleTopLevel,
    selectItem,
    deselectAt,
  } = useScopeBar({
    setManualScopes,
    customMaps: account?.customMaps,
    customObjectGroups: account?.customObjectGroups,
  });

  const selectionKey = selectedItems.map(i => i.id).join(",");

  return (
    <ScopeBarContainer>
      <HorizontalScrollBar
        scrollKey={selectionKey}
        containerCss={{
          display: "flex",
          alignItems: "center",
          gap: spacing.s,
        }}
        data-testid="search-scope-bar"
      >
        {selectedItems.length === 0 && (
          <ScopeChip selected aria-selected="true" data-testid="scope-chip-all">
            <Body size="default" type="emphasis" color="inherit">
              All
            </Body>
          </ScopeChip>
        )}

        {selectedItems.map((item, index) => {
          const isCancellable = !(hasSingleTopLevel && index === 0);
          return (
            <ScopeChip
              key={item.id}
              selected
              aria-selected="true"
              data-testid={`scope-chip-${item.id}`}
            >
              <Body size="default" type="emphasis" color="inherit">
                {item.label}
              </Body>
              {isCancellable && (
                <CancelButton
                  onPress={() => deselectAt(index)}
                  aria-label={`Remove ${item.label} filter`}
                >
                  <Icon iconName="x" color="contentSecondary" size={12} />
                </CancelButton>
              )}
            </ScopeChip>
          );
        })}

        {unselectedChildren.map(item => (
          <ScopeChip
            key={item.id}
            role="button"
            onClick={() => selectItem(item)}
            data-testid={`scope-chip-${item.id}`}
          >
            <Body size="default" type="emphasis" color="inherit">
              {item.label}
            </Body>
          </ScopeChip>
        ))}
      </HorizontalScrollBar>
    </ScopeBarContainer>
  );
};
